import React, { Component } from 'react';
import withAuth from '../components/withAuth';
import Menu from "../components/Menu";
import '../styles/Connect.css';
import { Route, Switch } from "react-router-dom";

import Website from "../components/Website";
import Threads from "../components/Threads";
import User from "../components/User";
import Comment from "../components/Comment";
import Debate from "../components/Debate";
import Deletewebsite from "../components/Deletewebsite";
import Data from "../components/Data";
import Funnel from "../components/Funnel";
import DeactivationFeedback from "../components/DeactivationFeedback";
import ModerationDashboard from "../components/ModerationDashboard/ModerationDashboard";
import Formpub from "../components/Formpub";
import Formnews from "../components/Formnews";
import Listenews from "../components/Listenews";
import Listlicence from "../components/Listlicence";
import Formlicence from "../components/Formlicence";
import Views from "../components/Views";
import Bills from "../components/Bills";
import Commentaires from "../components/Commentaires";
import StatViews  from "../components/StatViews";
import BlocsAffiches from "../components/BlocsAffiches";
import HostingDetected from "../components/HostingDetected";
import Pagesgd from "../components/Pagesgd";
import Redirection from "../components/Redirection";
import FormVip from "../components/FormVip";
import ListVip from "../components/ListVip";
import FormAnnouncement from "../components/FormAnnouncement";
import ListAnnouncements from "../components/ListAnnouncements";
import ReviewAnnouncement from "../components/ReviewAnnouncement";
import { Grid, Box, Button, Typography } from '@mui/material';

class DashboardLayout extends Component {
  constructor(props) {
    super(props);
    this.handleDeconnectClick = this.handleDeconnectClick.bind(this);
  }

  handleDeconnectClick() {
    localStorage.removeItem('gc_token');
    window.location.reload();
  }

  render() {
    return (
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={2}>
            <Box sx={{ p: 2 }}>
              <Menu />
              <Box sx={{ mt: 2 }}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={this.handleDeconnectClick}
                >
                  Disconnection
                </Button>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} md={10}>
            <Switch>
              <Route exact path="/super-admin/" component={withAuth(Data)}/>
              <Route exact path="/super-admin/funnel" component={withAuth(Funnel)}/>
              <Route exact path="/super-admin/deactivation-feedback" component={withAuth(DeactivationFeedback)}/>
              <Route exact path="/super-admin/moderation-ia" component={withAuth(ModerationDashboard)}/>
              <Route exact path="/super-admin/website" component={withAuth(Website)}/>
              <Route exact path="/super-admin/website/delete" component={withAuth(Deletewebsite)}/>
              <Route path="/super-admin/thread" component={withAuth(Threads)}/>
              <Route path="/super-admin/Formpub" component={withAuth(Formpub)}/>
              <Route path="/super-admin/User" component={withAuth(User)}/>
              <Route exact path="/super-admin/website/:website_id/comment" component={withAuth(Comment)}/>
              <Route exact path="/super-admin/website/:website_id/debate" component={withAuth(Debate)}/>
              <Route path="/super-admin/Formnews" component={withAuth(Formnews)}/>
              <Route path="/super-admin/Listenews" component={withAuth(Listenews)}/>
              <Route path="/super-admin/Listlicence" component={withAuth(Listlicence)}/>
              <Route path="/super-admin/ListVip" component={withAuth(ListVip)}/>
              <Route path="/super-admin/FormVip" component={withAuth(FormVip)}/>
              <Route path="/super-admin/Formlicence" component={withAuth(Formlicence)}/>
              <Route path="/super-admin/Views" component={withAuth(Views)}/>
              <Route path="/super-admin/Bills" component={withAuth(Bills)}/>
              <Route path="/super-admin/Commentaires" component={withAuth(Commentaires)}/>
              <Route path="/super-admin/StatViews" component={withAuth(StatViews)}/>
              <Route path="/super-admin/blocs-affiches" component={withAuth(BlocsAffiches)}/>
              <Route exact path="/super-admin/hosting-detected" component={withAuth(HostingDetected)}/>
              <Route path="/super-admin/Pagesgd" component={withAuth(Pagesgd)}/>
              <Route path="/super-admin/Redirection" component={withAuth(Redirection)}/>
              <Route path="/super-admin/FormAnnouncement" component={withAuth(FormAnnouncement)}/>
              <Route path="/super-admin/ListAnnouncements" component={withAuth(ListAnnouncements)}/>
              <Route path="/super-admin/ReviewAnnouncement" component={withAuth(ReviewAnnouncement)}/>
            </Switch>
          </Grid>

          <Grid item xs={12}>
            <Box sx={{ bgcolor: 'grey.900', color: 'common.white', p: 2, textAlign: 'center' }}>
              <Typography variant="body2">Copyright ©2019 Super-admin Semiologic</Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    );
  };
}

export default DashboardLayout;
